var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/afterpay-info/step2.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"i-afterpay-process-icon\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" x=\"0px\" y=\"0px\"\n     viewBox=\"0 0 100 100\" style=\"enable-background:new 0 0 100 100;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n    .st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n</style>\n<line class=\"st0\" x1=\"45.5\" y1=\"74.5\" x2=\"54.5\" y2=\"74.5\"/>\n<path class=\"st0\" d=\"M19.4,23.5h61.1c2.2,0,3.9,1.8,3.9,3.9l0,0v45.1l0,0h-69l0,0V27.4C15.5,25.3,17.3,23.5,19.4,23.5L19.4,23.5z\"/>\n<path d=\"M63.8,39.5L59.3,37l-4.5-2.6c-2.1-1.2-4.9-0.5-6.1,1.7c-0.4,0.7-0.6,1.5-0.6,2.2v0.6c0,0.3,0.2,0.6,0.4,0.8l2.1,1.2\n    c0.4,0.2,0.9,0.1,1.2-0.3c0.1-0.1,0.1-0.3,0.1-0.5v-1.4c0-0.5,0.4-0.9,0.9-0.9c0.2,0,0.3,0,0.4,0.1l4.1,2.4l4.1,2.4\n    c0.4,0.2,0.6,0.8,0.3,1.2c-0.1,0.1-0.2,0.3-0.3,0.3l-4,2.3l-4.1,2.4c-0.4,0.2-1,0.1-1.2-0.3C52,48.5,52,48.3,52,48.1v-0.6\n    c0-2.5-2-4.5-4.5-4.5c-0.8,0-1.6,0.2-2.2,0.6l-4.5,2.6l-4.5,2.5c-2.1,1.2-2.9,4-1.6,6.1c0.4,0.7,1,1.3,1.6,1.6l4.5,2.5l4.5,2.6\n    c2.1,1.2,4.9,0.5,6.1-1.7c0.4-0.7,0.6-1.5,0.6-2.2V57c0-0.3-0.2-0.6-0.4-0.8L49.5,55c-0.4-0.2-0.9-0.1-1.2,0.3\n    c-0.1,0.1-0.1,0.3-0.1,0.5v1.4c0,0.5-0.4,0.9-0.9,0.9c-0.2,0-0.3,0-0.4-0.1l-4.1-2.4l-4.1-2.4c-0.4-0.2-0.6-0.8-0.3-1.2\n    c0.1-0.1,0.2-0.3,0.3-0.3l4.1-2.4l4.1-2.4c0.4-0.2,1-0.1,1.2,0.3c0.1,0.1,0.1,0.3,0.1,0.5v0.8c0,2.5,2,4.5,4.5,4.5\n    c0.8,0,1.6-0.2,2.2-0.6l4.5-2.6l4.5-2.5c1.9-1.6,1.9-4.8,0.3-6.7C63.8,40.3,63.6,40.1,63.8,39.5z\"/>\n<path class=\"st0\" d=\"M12.5,72.5h75c1.1,0,2,0.9,2,2l0,0c0,1.1-0.9,2-2,2h-75c-1.1,0-2-0.9-2-2l0,0C10.5,73.4,11.4,72.5,12.5,72.5z\"\n    />\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/afterpay-info/step2.j2"] , dependencies)